
export const durationTrainingRange = {
  0: {min:null,max:30},
  1: {min:30, max:40},
  2: {min:40, max:50},
  3: {min:50,max:null},
  4: {min:null, max:null},
};